import { Controller } from "@hotwired/stimulus";
import { CodeJar } from "codejar";
import hljs from "hb/hljs";

export default class extends Controller {
  static targets = ["input"];

  connect() {
    const textarea = this.inputTarget;

    const editorDiv = document.createElement("div");
    editorDiv.className = "code-editor-content";
    editorDiv.style.height = "60vh";
    editorDiv.style.maxHeight = "60vh";
    editorDiv.style.whiteSpace = "pre";
    editorDiv.style.overflowX = "auto";
    editorDiv.style.overflowY = "auto";
    textarea.parentElement.insertBefore(editorDiv, textarea);

    const highlight = (editor) => {
      const code = editor.textContent;
      editor.innerHTML = hljs.highlight(code, { language: "yaml" }).value;
    };

    this.jar = CodeJar(editorDiv, highlight, {
      tab: "  ",
      indentOn: /[:]$/,
    });

    this.jar.updateCode(textarea.value);

    this.jar.onUpdate((code) => {
      textarea.value = code;
    });

    textarea.style.display = "none";
  }

  disconnect() {
    if (this.jar) {
      this.jar.destroy();
    }
  }
}
